import { BUYER, SELLER } from "codes";
import { useAppSelector } from "redux/hooks";
import { useLocation } from "react-router";
// eslint-disable-next-line import/no-unresolved
import buyerHtml from "./documents/buyer.html?raw";
// eslint-disable-next-line import/no-unresolved
import supplierHtml from "./documents/supplier.html?raw";
import GtcContent from "./GtcContent";

const resolveGtcHtml = (pathname: string, profile: string) => {
  const normalizedProfile = profile.toLowerCase();

  if (
    pathname === "/marketplace/gtc-buyers" ||
    normalizedProfile === BUYER.toLowerCase()
  ) {
    return buyerHtml;
  }

  if (
    pathname === "/marketplace/gtc-suppliers" ||
    normalizedProfile === SELLER
  ) {
    return supplierHtml;
  }

  return "";
};

const GeneralTermsCondition = () => {
  const profile = useAppSelector((state) => state.appState.profile);
  const { pathname } = useLocation();
  const gtcHtml = resolveGtcHtml(pathname, profile);

  return <GtcContent html={gtcHtml} />;
};

export default GeneralTermsCondition;
